module.exports = __webpack_public_path__ + "static/media/606346899_thumbnail.bb9310d3.jpg";